import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { AppRouterProvider } from './providers/routerProvider.tsx'
import {HeroUIProvider} from '@heroui/react'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HeroUIProvider>
      <AppRouterProvider />
    </HeroUIProvider>
  </StrictMode>
)
